import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3f8bca74"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "basic-info" }
const _hoisted_2 = { class: "detail-block" }
const _hoisted_3 = { class: "info-head df aic" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title-block" }, null, -1))
const _hoisted_5 = {
  class: "info-head-title",
  style: {"flex":"1","line-height":"32px"}
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "基本信息", -1))
const _hoisted_7 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_8 = { class: "detail-item-block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_v_preview_item = _resolveComponent("v-preview-item")!
  const _component_v_preview = _resolveComponent("v-preview")!
  const _component_BasicInfo = _resolveComponent("BasicInfo", true)!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("span", _hoisted_5, [
            _hoisted_6,
            _createVNode(_component_el_button, {
              class: "card-header-btn",
              icon: _ctx.EditPen,
              type: "text",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.edit()))
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            }, 8, ["icon"])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_v_preview, {
            itemTopSpace: "5px",
            "label-width": "130px",
            style: {"margin":"0 auto"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_preview_item, {
                width: "50%",
                label: "身份证号"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.detail.idCard), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_v_preview_item, {
                width: "50%",
                label: "微信号"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.detail.weChat), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_v_preview_item, {
                width: "50%",
                label: "参加工作时间",
                type: "date",
                content: _ctx.detail.startWorkTime
              }, null, 8, ["content"]),
              _createVNode(_component_v_preview_item, {
                width: "50%",
                label: "户口所在地"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.detail.hukouName), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_v_preview_item, {
                width: "50%",
                label: "现居地址"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.detail.currentName), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_v_preview_item, {
                width: "100%",
                label: "自我评价",
                content: _ctx.detail.selfEvaluate,
                type: "textarea"
              }, null, 8, ["content"])
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.dialogVisible,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dialogVisible) = $event)),
      title: "编辑基本信息",
      width: "880px",
      "destroy-on-close": true
    }, {
      default: _withCtx(() => [
        _createVNode(_component_BasicInfo, {
          isDialog: true,
          closeDialog: _ctx.closeDialog,
          basicInfoForm: _ctx.basicInfoForm,
          successCallBack: _ctx.save
        }, null, 8, ["closeDialog", "basicInfoForm", "successCallBack"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}